import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { ArrowForward } from '@mui/icons-material';
import One from './One';
import Two from './Two';
import Three from './Three';
import Four from './Four';
import Five from './Five';

const componentMap = {
  One: <One />,
  Two: <Two />,
  Three: <Three />,
  Four: <Four />,
  Five: <Five />,
};

const BannerText = ({ content }) => {
  return (
    <Container fluid className="py-5 banner-text">
      <Row>
        <Col>
          <p className="banner-heading" style={{ lineHeight: '60px' }}>
            <span className="powered">
              {content.bannerText.heading.split(':')[0]}:{' '}
              <span className="automation">
                {content.bannerText.heading.split(':')[1]}
              </span>
            </span>
          </p>
        </Col>
      </Row>

      {content.bannerText.items.map((item, index) => (
        <Row key={index}>
          <Col className="d-flex align-items-center">
            <div className="p-2 pb-3">{componentMap[item.component]}</div>
            <div>
              <p className="text-standard ml-2">
                <strong>{item.title}</strong>
                <br />
                {item.info}
              </p>
            </div>
          </Col>
        </Row>
      ))}

      <Row className="mt-2">
        <Col>
          <a
            target="_blank"
            rel="noreferrer"
            href={content.bannerText.ctaLink}
            className="btn-rounded hire-expert btn btn-primary">
            {content.bannerText.ctaText} <ArrowForward fontSize="18px" />
          </a>
        </Col>
      </Row>
    </Container>
  );
};

export default BannerText;
